const ChaChaCongelado = {
    name: "Cha Cha Congelado",
    bpm: 116,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default ChaChaCongelado;